var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Pourcentage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "96px",
    height: "96px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 37.46875 5.984375 A 1.50015 1.50015 0 0 0 36.339844 6.5507812 L 9.3398438 39.550781 A 1.50015 1.50015 0 1 0 11.660156 41.449219 L 38.660156 8.4492188 A 1.50015 1.50015 0 0 0 37.46875 5.984375 z M 13.5 7 C 9.9294345 7 7 9.9294345 7 13.5 L 7 17.5 C 7 21.070565 9.9294345 24 13.5 24 C 17.070565 24 20 21.070565 20 17.5 L 20 13.5 C 20 9.9294345 17.070565 7 13.5 7 z M 13.5 10 C 15.443435 10 17 11.556565 17 13.5 L 17 17.5 C 17 19.443435 15.443435 21 13.5 21 C 11.556565 21 10 19.443435 10 17.5 L 10 13.5 C 10 11.556565 11.556565 10 13.5 10 z M 34.5 24 C 30.929435 24 28 26.929435 28 30.5 L 28 34.5 C 28 38.070565 30.929435 41 34.5 41 C 38.070565 41 41 38.070565 41 34.5 L 41 30.5 C 41 26.929435 38.070565 24 34.5 24 z M 34.5 27 C 36.443435 27 38 28.556565 38 30.5 L 38 34.5 C 38 36.443435 36.443435 38 34.5 38 C 32.556565 38 31 36.443435 31 34.5 L 31 30.5 C 31 28.556565 32.556565 27 34.5 27 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Pourcentage);
export default __webpack_public_path__ + "static/media/icons8-pourcentage.1dcb84f04bf4a900ee4051645182bad1.svg";
export { ForwardRef as ReactComponent };